<script>
import TextareaField from '@phoenix/mixins/components/form/fields/TextareaField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [TextareaField],

  setup(props) {
    return useField(props);
  },

  computed: {
    customFieldClasses() {
      return ['input--textarea', this.fieldClasses];
    },
  },
};
</script>

<template>
  <textarea
    :id="fieldUniqueId"
    v-model="value"
    :name="field.name"
    :class="customFieldClasses"
    :aria-describedby="ariaDescribedby"
    :aria-label="field.ariaLabel"
    :placeholder="placeholderOrLabel"
    :rows="field.rows || rows"
    :disabled="field.disabled"
    @focus="pushFieldDataTracking"
  />
</template>
